import Vue from 'vue'
import Vuex from 'vuex'
import router from './../router'
import loading from './modulos/loading'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    token: null,
    usuario: {
      usuarioId: null,
      nome: null,
      email: null,
      login: null,
      aspl: null
    },
    recarregar: false,
    requestErro: ''
  },

  mutations: {

    registraUsuario (state, token) {
      let decodedToken = Vue.$jwt.decode(token)
      state.token = token
      state.usuario.usuarioId = decodedToken.usrId
      state.usuario.nome = decodedToken.usrName
      state.usuario.login = decodedToken.usrLogin
      state.usuario.email = decodedToken.usrEmail
      state.usuario.asplFlag = decodedToken.usrAsplFlag
    },

    limpaUsuario (state) {
      state.token = null
      state.usuario.usuarioId = null
      state.usuario.nome = null
      state.usuario.login = null
      state.usuario.email = null
      state.usuario.asplFlag = null
      state.usuario.credores = null
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('expirationDate')
      router.push('/login')
    },

    UPDATE_RECARREGAR (state, status) {
      state.recarregar = status
    },

    SET_REQUEST_ERROR (state, error) {
      state.requestErro = error
    }
  },

  actions: {

    setLogoutTimer ({ commit }, expirationTime) {
      setTimeout(() => {
        commit('limpaUsuario')
      }, expirationTime)
    },

    login ({ commit, dispatch, state }, authData) {
      commit('registraUsuario', authData.accessToken)
      let tFim = new Date(authData.expiraEm)
      let tInicio = new Date(authData.criadoEm)
      let tempoExpirar = tFim.getTime() - tInicio.getTime()
      let agora = Vue.moment(new Date())
      let localExpiraEm = agora.add(tempoExpirar, 'ms')
      localStorage.setItem('token', authData.accessToken)
      localStorage.setItem('userId', state.usuario.usuarioId)
      localStorage.setItem('localExpirationDate', localExpiraEm)
      dispatch('setLogoutTimer', tempoExpirar)
    },

    logout ({ commit }) {
      commit('limpaUsuario')
    },

    tryAutoLogin ({commit}) {
      const token = localStorage.getItem('token')
      if (!token) {
        return
      }
      const expirationDate = new Date(localStorage.getItem('localExpirationDate'))
      const now = new Date()
      if (now >= expirationDate) {
        commit('limpaUsuario')
        return
      }
      commit('registraUsuario', token)
    },

    setRecarregar ({ commit }, status) {
      commit('UPDATE_RECARREGAR', status)
    },

    setRequestError ({ commit }, error) {
      commit('SET_REQUEST_ERROR', error)
    }
  },

  getters: {

    usuario (state) {
      return state.usuario
    },

    estaAutenticado (state) {
      if (state.usuario.asplFlag === 'True') {
        router.push('/atualizarsenha')
      }
      return state.token !== null
    },

    getToken (state) {
      return state.token
    },

    recarregar (state) {
      return state.recarregar
    },

    requestErro (state) {
      return state.requestErro
    }
  },

  modules: {
    loading
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js